import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ViewWorkshopJobStoreService } from '../../view-workshop-job-store.service';
import { DialogRef } from '@angular/cdk/dialog';
import { WaitiningForPartsEvent } from '../../../../models/workshop-job-event';
import { WORKSHOP } from '../../../../../testIds';
import { MatButton } from '@angular/material/button';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatInput } from '@angular/material/input';
import { TestIdDirective } from '../../../../shared/directives/test-id.directive';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';

@Component({
    selector: 'app-waiting-for-parts-dialog',
    templateUrl: './waiting-for-parts-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatDialogTitle, ReactiveFormsModule, MatDialogContent, MatFormField, TestIdDirective, MatLabel, MatInput, CdkTextareaAutosize, MatDialogActions, MatButton, MatDialogClose]
})
export class WaitingForPartsDialogComponent {
  testIds = WORKSHOP;
  form = new FormGroup({
    notes: new FormControl<string>(null)
  });

  constructor(
    private store: ViewWorkshopJobStoreService,
    private dialog: DialogRef<WaitingForPartsDialogComponent>
  ) {}

  saveWaitingForParts() {
    const { notes } = this.form.value;
    const event: Partial<WaitiningForPartsEvent> = {
      type: 'waiting_for_parts',
      details: {
        notes
      }
    };
    this.store.addEvent({ event, onSuccess: () => this.dialog.close() });
  }
}
